"use client"

import { createContext, useContext } from "react";
import type { CardVariant } from "./_types";

type CardContextType = {
  variant: CardVariant;
}

export const CardContext = createContext<CardContextType | null>(null)

export function useCard() {
  const ctx = useContext(CardContext)

  if (!ctx) {
    throw new Error("Card components must be used inside fucking Plan")
  }

  return ctx
}
